export default "__VITE_ASSET__C0w1_fam__"